const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+SKU+Detail+API

// (!) As of 8/29/2017 this seems to be unused.

function getSkuDetails(skuId) {
    const url = '/api/catalog/skus/' + skuId;

    return ufeApi.makeRequest(url).
        then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = getSkuDetails;
